import GuideSDK from "../../../../src/mdx/sdk/guide.mdx";
import * as React from 'react';
export default {
  GuideSDK,
  React
};